<div *ngIf="header">
    <div class="top-section-content">
        <div *ngFor="let fieldKey of getFieldsKeys('topSection')" class="section-field">
            <div *ngIf="!header['topSection'].fields[fieldKey].hidden" class="field-wrapper">

                <teiasoft-datetime *ngIf="header['topSection'].fields[fieldKey].type === 'date'"
                    [type]="header['topSection'].fields[fieldKey].type"
                    [labelText]="header['topSection'].fields[fieldKey].label | translate"
                    [isRequired]="header['topSection'].fields[fieldKey].required"
                    [value]="header['topSection'].fields[fieldKey].value"
                    (onChange)="onFieldChange('topSection', fieldKey, $event)" size="s-label" [dateFormat]="globals.dateFormat!">
                </teiasoft-datetime>

                <teiasoft-input *ngIf="header['topSection'].fields[fieldKey].type !== 'date'"
                    [type]="header['topSection'].fields[fieldKey].type"
                    [labelText]="header['topSection'].fields[fieldKey].label | translate"
                    [isRequired]="header['topSection'].fields[fieldKey].required"
                    [readOnly]="!header['topSection'].fields[fieldKey].editable"
                    [value]="header['topSection'].fields[fieldKey].value"
                    (onInput)="onFieldChange('topSection', fieldKey, $event)" size="s">
                </teiasoft-input>

            </div>
            <div *ngIf="header['topSection'].fields[fieldKey].hideable" class="hide-toggle">
                <i (click)="toggleFieldVisibility('topSection', fieldKey)"
                    [ngClass]="header['topSection'].fields[fieldKey].hidden ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </div>
        </div>
    </div>
    <div class="middle-section-content">
        <div *ngFor="let fieldKey of getFieldsKeys('middleSection')" class="section-field">
            <div class="field-wrapper">
                <teiasoft-input [type]="header['middleSection'].fields[fieldKey].type"
                    [labelText]="header['middleSection'].fields[fieldKey].label | translate"
                    [isRequired]="header['middleSection'].fields[fieldKey].required"
                    [readOnly]="!header['middleSection'].fields[fieldKey].editable"
                    [value]="header['middleSection'].fields[fieldKey].value"
                    (onInput)="onFieldChange('middleSection', fieldKey, $event)" size="s"
                    [ngClass]="header['middleSection'].fields[fieldKey].hidden ? 'hidden':''">
                </teiasoft-input>
            </div>

            <div *ngIf="header['middleSection'].fields[fieldKey].hideable" class="hide-toggle" sty>
                <i (click)="toggleFieldVisibility('middleSection', fieldKey)"
                    [ngClass]="header['middleSection'].fields[fieldKey].hidden ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </div>
        </div>
    </div>
    <div class="bottom-section-content">
        <div class="refresh">
            <app-document-editor-menu [editor]="editor" [toolbar]="toolbar"></app-document-editor-menu>
            <button (click)="reset()" class="fas fa-undo">
            </button>
        </div>
        <ngx-editor [editor]="editor" [(ngModel)]="this.header.bottomSection.value"
            (ngModelChange)="onBottomSectionChange($event)">
        </ngx-editor>
    </div>
</div>
